import { AppDRUMStrategy } from '@nab/nab-x-sdk-browser';

const httpsToHttpRegex = '/https/i'

export const getRumStrategy = () => new AppDRUMStrategy({
  libraryUrl: 'https://cdn.appdynamics.com/adrum/adrum-4.5.17.2890.js',
  configValue: {
    appKey: 'SY-AAB-AYC',
    adrumExtUrlHttp: 'http://cdn.appdynamics.com',
    adrumExtUrlHttps: 'https://cdn.appdynamics.com',
    beaconUrlHttp: 'https://syd-col.eum-appdynamics.com'.replace(httpsToHttpRegex, 'http'),
    beaconUrlHttps: 'https://syd-col.eum-appdynamics.com',
    xd: {
      enable: true,
    },
    spa: {
      spa2: true,
    }
  }
});
